/**
 * Auth feature — EN copy (Stitch rebuild, DEC-051).
 *
 * Maps the Stitch `authentication_career_intelligence` copy onto Workerize:
 * CareerAura → Workerize, "ENTER ECOSYSTEM"/"Join the Ecosystem" →
 * truthful Workerize copy, "neural engine" overclaim de-hyped. Visual-only
 * (no backend); social providers (Google/Microsoft per DEC-028) are disabled.
 */

export const authEn = {
  'auth.login.title': 'Welcome back',
  'auth.login.subtitle': 'Sign in to your Workerize intelligence workspace.',
  'auth.register.title': 'Create your account',
  'auth.register.subtitle': 'Start turning your career signals into direction.',

  'auth.mode.login': 'Sign in',
  'auth.mode.register': 'Create account',

  'auth.field.email.label': 'Email address',
  'auth.field.email.placeholder': 'you@example.com',
  'auth.field.firstName.label': 'First name',
  'auth.field.firstName.placeholder': 'Jane',
  'auth.field.lastName.label': 'Last name',
  'auth.field.lastName.placeholder': 'Doe',
  'auth.field.password.label': 'Password',
  'auth.field.password.placeholder': '••••••••',
  'auth.field.password.forgot': 'Forgot?',
  'auth.field.confirm.label': 'Confirm password',

  'auth.submit.login': 'Sign in',
  'auth.submit.register': 'Create account',
  'auth.submit.loading': 'Working',
  'auth.logout': 'Sign out',
  'auth.error.passwordMismatch': 'Passwords do not match.',
  'auth.callback.loading': 'Completing sign-in…',

  'auth.social.divider': 'Or continue with email',
  'auth.social.google': 'Continue with Google',
  'auth.social.comingSoon': 'Social sign-in is coming soon',
  'auth.social.disabled.title': 'Google sign-in not enabled',
  'auth.social.disabled.body':
    'Google sign-in is not configured on this deployment yet. Use email, or request early access.',

  'auth.terms.lead': 'By continuing, you agree to our',
  'auth.terms.terms': 'Terms',
  'auth.terms.and': 'and',
  'auth.terms.privacy': 'Privacy Policy',

  'auth.switch.toRegister.prompt': 'New to Workerize?',
  'auth.switch.toRegister.action': 'Create an account',
  'auth.switch.toLogin.prompt': 'Already have an account?',
  'auth.switch.toLogin.action': 'Sign in',

  'auth.preview.note': 'Accounts are connected to the live Workerize API.',

  'auth.value.badge': 'AI-NATIVE',
  'auth.value.headline.lead': 'Turn your signals into',
  'auth.value.headline.accent': 'upward motion.',
  'auth.value.subtitle':
    'Workerize reads the talent landscape and maps your path toward mastery — in Arabic and English.',
  'auth.value.benefit1.title': 'Understand your strengths',
  'auth.value.benefit1.body':
    'Workerize surfaces the latent skills and strengths you did not know you had.',
  'auth.value.benefit2.title': 'See your growth gaps',
  'auth.value.benefit2.body':
    'Get precise, ranked next moves to learn what keeps you ahead of the curve.',
  'auth.value.trust': 'Private by design · MENA-first · bilingual',
} as const;

export type AuthEn = typeof authEn;
